import CourseQuizTab from './CourseQuizTab';

export default CourseQuizTab;
